import {CSSProperties, FC} from 'react';


export interface IIconOilBmwProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconOilBmw: FC<IIconOilBmwProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path d="M21.126 11.763a.67.67 0 0 0-.614-.444l-4.672-.112-3.085-1.15.43-1.15.025.009a.67.67 0 1 0 .468-1.256l-2.59-.965a.67.67 0 1 0-.469 1.255l.054.02-.428 1.151L7.15 7.97 5.647 5.174a.67.67 0 0 0-.868-.292l-2.387 1.09a.67.67 0 0 0-.266 1l3.006 4.192L3.87 14.55a.668.668 0 0 0 .394.862l8.893 3.315a.668.668 0 0 0 .671-.12l7.104-6.11a.67.67 0 0 0 .194-.734ZM3.69 6.853l1.075-.491L6.04 8.73l-.343.921L3.69 6.853Z" />
        </svg>
    );
};
